import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseAbstractApi } from './base-abstract.api';

// B -> Backend api model
// BL -> Backend List item api model
@Injectable()
export abstract class MultiBaseAbstractApi<B, BL, IdType = number> extends BaseAbstractApi<B, IdType> {
    abstract getList(): Observable<BL[]>;
}
